export default "__VITE_ASSET__50771cd5__"